import {observable} from "mobx";
import api from "../../Services/Api";
import AutoCatalogStore from "../../Components/AutoCatalog/AutoCatalogStore";

class AutoCatalogWidgetStore {
    @observable contextKey?: string;
    @observable entityHrefIds: string[] = [];
    store: AutoCatalogStore;

    constructor() {
        this.store = new AutoCatalogStore();
    }

    async init(contextKey: string, entityHrefIds: string[]) {
        this.contextKey = contextKey;
        this.entityHrefIds = entityHrefIds;
        const authSuccess = await api.auth(contextKey);
        if (authSuccess) {
            await this.store.init(entityHrefIds);
        }
    }

    cleanup() {
        this.contextKey = undefined;
    }
}

const autoCatalogWidgetStore = new AutoCatalogWidgetStore();
export default autoCatalogWidgetStore;
